<template>
  <div>
    <div :class="{'mobileSteps': mobile == 1}">
      <el-steps :align-center="true" process-status="finish" finish-status="finish" :active="active">
        <el-step icon="el-icon-success" :title="$t('help.appeal')"></el-step>
        <el-step icon="el-icon-success" :title="$t('help.contactInfor')"></el-step>
        <el-step icon="el-icon-success" :title="$t('help.accountInfor')"></el-step>
        <el-step icon="el-icon-success" :title="$t('help.completeAppeal')"></el-step>
      </el-steps>
      <div v-if="active==0">
        <div class="step1-text">
          <p>{{$t('help.appealPrompt1')}}</p>
          <p>{{$t('help.appealPrompt2')}}</p>
          <div>
            <el-form :rules="startFormRules" :label-position="right" ref="startForm" style="margin-top:20PX"
              :model="startForm" label-width="135PX">
              <el-form-item :label="$t('help.appealAccount')" :error="errorUser" class="before-label-div"
                prop="startFormUser">
                <el-input v-model="startForm.startFormUser" :placeholder="$t('help.placeholder1')" style="width:250PX;">
                </el-input>
              </el-form-item>
              <el-form-item :label="$t('help.businessType')">
                <el-select v-model="startForm.startFormType" style="width:250PX;">
                  <el-option :label="$t('help.gameUsers')" value="Game-users"></el-option>
                  <!-- <el-option label="商城用户" value="shangcheng"></el-option>
                  <el-option label="云服务用户" value="yunfuwu"></el-option>
                  <el-option label="其他用户" value="qita"></el-option> -->
                </el-select>
              </el-form-item>
              <!-- <span class="form-span">申诉基本资料</span>
              <el-form-item label="真实姓名:" prop="startFormUser">
                <el-input v-model="startForm.startFormUser" placeholder="请输入您的中文真实姓名" style="width:250PX;"></el-input>(必填)
              </el-form-item>
              <el-form-item label="证件号码:" prop="startFormNumber">
                <el-input v-model="startForm.startFormNumber" placeholder="请输入18位身份证号" style="width:250PX;" ></el-input>(必填)
              </el-form-item> -->
              <div class="btn-div">
                <el-button class="back" type="primary" @click="goHome">{{$t('help.back')}}</el-button>
                <el-button class="btn" type="primary" @click="next('startForm')">{{$t(
                  'help.nextStep')}}</el-button>
              </div>
            </el-form>
          </div>
        </div>

      </div>
      <div v-if="active==1" class="step2-text">
        <el-form :rules="contactFormRules" ref="contactForm" label-position="right" :model="contactForm"
          label-width="130PX">
          <span class="form-span">{{$t('help.contactFill')}}</span>
          <el-form-item :label="$t('help.appealAccount')">
            <el-input :disabled="true" v-model.trim="contactForm.contactFormUser" style="width:250PX;"></el-input>
          </el-form-item>
          <el-form-item :label="$t('help.contactDetails')">
            <el-checkbox :disabled="true" v-model="contactForm.contactFormIsEmail" :class="{'mobilei18n': this.$i18n.locale !== 'en_US' && mobile == 1}">{{$t('help.receiveEmail')}}
            </el-checkbox>
          </el-form-item>
          <el-form-item class="before-label-div enterEmailClass" prop="contactFormEmail" :error="emailNull"
            :label="$t('help.ContactEmail')">
            <el-input :disabled="!contactForm.contactFormIsEmail" v-model="contactForm.contactFormEmail" maxlength="50"
              :placeholder="$t('help.enterEmail')" style="width:250PX;"></el-input>
            <span style="display: inline-block;line-height:19PX;">{{$t('help.appealResult')}}</span>
          </el-form-item>
          <el-form-item :label="$t('help.code')" :error="errorMsg" prop="contactFormCode">
            <el-input v-model="contactForm.contactFormCode" :placeholder="$t('help.enterCode')" style="width:250PX;"
              class="getCodeInput">
            </el-input>
            <el-button class="btnCose getCodeButton" :disabled="totalCount > 0" type="primary" @click="getCode">
              {{btnText}}
            </el-button>
          </el-form-item>
          <span style="display: inline-block;font-size:14PX;">{{$t('help.Note')}}</span>
          <div class="btn-div">
            <el-button class="back" type="primary" @click="back('contactForm')">{{$t('help.Previous')}}</el-button>
            <el-button class="btn" type="primary" @click="next('contactForm')">{{$t('help.nextStep')}}</el-button>
          </div>
        </el-form>
      </div>
      <div v-if="active==2">
        <div class="step2-text">

          <el-form :rules="appealInfoRules" ref="appealInfo" label-position="right" :model="appealInfo"
            label-width="160PX">
            <span class="form-span">{{$t('help.basicAccountInfor')}}</span>
            <span class="tip-span">{{$t('help.required')}}</span>
            <el-form-item :label="$t('help.appealAccount')">
              <el-input :disabled="true" v-model.trim="appealInfo.appealAccount" style="width:250PX;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('help.usedEmail')" :error="errorUsedEmail">
              <el-input v-model="appealInfo.usedEmail" maxlength="50" :placeholder="$t('help.enterUsedEmail')"
                style="width:250PX;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('help.usedphone')" :error="errorUsedPhone">
              <el-input v-model="appealInfo.usedPhone" maxlength="11" :placeholder="$t('help.enterUsedphone')"
                style="width:250PX;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('help.registrationTime')">
              <el-input v-model="appealInfo.registTime" :placeholder="$t('help.enterRegistrationTime')"
                style="width:250PX;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('help.name')" prop="realName" class="before-label-div">
              <el-input v-model="appealInfo.realName" :placeholder="$t('help.chineseName')" style="width:250PX;">
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('help.idNumber')" prop="IDCard" class="before-label-div">
              <el-input v-model="appealInfo.IDCard" :placeholder="$t('help.idName')" style="width:250PX;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('help.idPhoto')" :required="true" :error="errorUserImg" class="before-label-div">
              <el-upload :action="actionURl" :limit="2" :file-list="productImgs" :multiple="isMultiple"
                :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload" :on-exceed="handleExceed" :on-error="imgUploadError"
                :auto-upload="true" list-type="picture">
                <el-button size="small" class="up-btn" type="primary">{{$t('help.upload')}}</el-button>
                <div slot="tip" class="el-upload__tip">{{$t('help.uploadPhotos')}}</div>
                <div slot="tip" class="el-upload__tip">{{$t('help.imageExceed')}}</div>
                <div slot="tip" class="el-upload__tip">{{$t('help.onlyUsed')}}</div>
                <div slot="tip" class="el-upload__tip">{{$t('help.noId')}}</div>
              </el-upload>
            </el-form-item>
          </el-form>
          <el-form :rules="gameFormRules" v-if="startForm.startFormType == 'Game-users'" ref="gameForm"
            :model="gameForm" label-width="160PX">
            <span v-if="startForm.startFormType != 'qita'" class="form-span">{{$t('help.accountUseInfor')}}</span>
            <el-form-item :label="$t('help.gameName')" prop="gameName" class="before-label-div">
              <el-input v-model="gameForm.gameName" :placeholder="$t('help.Gamename3')" style="width:250PX;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('help.gameService')" prop="gameArea" class="before-label-div">
              <el-input v-model="gameForm.gameArea" :placeholder="$t('help.gameService1')" style="width:250PX;">
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('help.gameNicknames')" prop="gameNickname" class="before-label-div">
              <el-input v-model="gameForm.gameNickname" :placeholder="$t('help.gameNicknames1')" style="width:250PX;">
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('help.gameID')" prop="gameID" class="before-label-div">
              <el-input v-model="gameForm.gameID" :placeholder="$t('help.gameID1')" style="width:250PX;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('help.rechargeOrder')" :required="true" :error="errorreChargeOrderImg"
              class="before-label-div">
              <el-upload class="upload-demo" :action="actionURl" :limit="5"
                :file-list="gameproductImgs" :multiple="gameisMultiple" :on-preview="gamehandlePictureCardPreview"
                :on-remove="gamehandleRemove" :on-success="gamehandleAvatarSuccess"
                :before-upload="gamebeforeAvatarUpload" :on-exceed="gamehandleExceed" :on-error="gameimgUploadError"
                :auto-upload="true" list-type="picture">
                <el-button size="small" class="up-btn" type="primary">{{$t('help.upload')}}</el-button>
                <div slot="tip" class="el-upload__tip">{{$t('help.imageExceed')}}</div>
                <div slot="tip" class="el-upload__tip">{{$t('help.imageExceed2')}}</div>
                <div slot="tip" class="el-upload__tip">{{$t('help.imageExceed3')}}</div>
              </el-upload>
            </el-form-item>
            <el-form-item :label="$t('help.otherInfor')">
              <el-input type="textarea" :rows="2" v-model="gameForm.otherInfo" style="width:250PX;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('help.service')" class="before-label-div">
              <p class="serveP">{{$t('help.cService')}}</p>
              <a class="serveImg" href="http://q.url.cn/cdqnjP?_type=wpa&qidian=true" target="_blank">
                <img src="../../assets/mobile/serve.png" alt=""><span>{{$t('help.oService')}}</span>
              </a>
            </el-form-item>
          </el-form>
          <el-form v-if="startForm.startFormType == 'shangcheng'" ref="mallForm" :model="mallForm" label-width="100PX">
            <el-form-item :label="$t('help.deliveryAddress')">
              <el-input v-model="mallForm.mallFormAddress" :placeholder="$t('help.addressUsed')" style="width:250PX;">
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('help.consumptionInfor')">
              <el-input v-model="mallForm.mallFormInfo" :placeholder="$t('help.enterConsumptionInfor')"
                style="width:250PX;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('help.douInfor')">
              <el-input v-model="mallForm.mallFormLedou" :placeholder="$t('help.enterDouInfor')" style="width:250PX;">
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('help.orderNo')">
              <el-input v-model="mallForm.mallFormOrder" :placeholder="$t('help.enterOrderNo')" style="width:250PX;">
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('help.addInfor')">
              <el-input v-model="mallForm.mallFormOther" style="width:250PX;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('help.otherInfor')">
              <el-input type="textarea" :rows="2" style="width:250PX;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('help.service')">

              <el-input type="textarea" :rows="2" style="width:250PX;"></el-input>
            </el-form-item>
            <!-- <el-button class="btnCose getCodeButton" :disabled="totalCount > 0" type="primary" @click="getCode" >{{btnText}}
            </el-button> -->

          </el-form>
          <el-form v-if="startForm.startFormType == 'yunfuwu'" ref="cloudServiceForm" :model="cloudServiceForm"
            label-width="100PX">
            <el-form-item :label="$t('help.backupData')">
              <el-input v-model="cloudServiceForm.cloudServiceFormType" :placeholder="$t('help.photoContact')"
                style="width:250PX;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('help.lastTime')">
              <el-input v-model="cloudServiceForm.cloudServiceFormTime" :placeholder="$t('help.enterLastTime')"
                style="width:250PX;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('help.photosBacked')">
              <el-input v-model="cloudServiceForm.cloudServiceFormPhoto" style="width:250PX;"></el-input>
            </el-form-item>
          </el-form>
          <div class="btn-div" style="margin-left: 30PX;">
            <el-button class="back" type="primary" @click="back(['appealInfo','gameForm'])">{{$t('help.Previous')}}
            </el-button>
            <el-button class="btn" type="primary" :disabled="bntDisabled" :loading="btnLoading"
              @click="next(['appealInfo','gameForm'])">{{$t('help.nextStep')}}</el-button>
          </div>
        </div>
      </div>
      <div v-if="active==3" class="step3-text">
        <span class="step3-title">{{$t('help.complaintAccepted')}}</span>
        <div>
          <span>{{$t('help.workingDay')}}&nbsp;&nbsp;{{contactForm.contactFormEmail}}</span>
          <br />
          <span>{{$t('help.workingDay7')}}</span>
        </div>
        <div class="btn-div" style="padding-top:40PX;">
          <el-button class="ok-btn" type="primary" @click="$router.push('/')">{{$t('help.done')}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import apiUrl from '@/utils/api' //api 接口
  import {
    isEmail,
    isMobile
  } from "../../utils/validate";
  export default {
    props: ['mobile'],
    data() {
      // var isStep ;
      // if( Number(sessionStorage.getItem('isStep')) != 0 && sessionStorage.getItem('isStep')){
      //    isStep = Number(sessionStorage.getItem('isStep'))
      // }else{
      //   isStep = 0 
      //   sessionStorage.setItem("isStep", 0);
      // }
      return {
        btnLoading: false,
        right: 'right',
        bntDisabled: false,
        errorUser: "",
        errorreChargeOrderImg: "",
        errorUserImg: "",
        errorUsedEmail: "",
        errorUsedPhone: "",
        gamedialogImageUrl: '',
        gamedialogVisible: false,
        gameproductImgs: [],
        gameisMultiple: true,
        dialogImageUrl: '',
        dialogVisible: false,
        productImgs: [],
        isMultiple: true,
        fileList: [],
        actionURl: "/appeal/fileUpload",
        emailNull: '',
        errorMsg: '',
        checked: false,
        disabled: false,
        active: 0,
        startForm: {
          startFormUser: "",
          startFormType: "Game-users",
        },
        startFormRules: {
          startFormUser: [{
            required: true,
            message: this.$t('help.enterGrievanceAccount'),
            trigger: "blur"
          }],
        },
        contactForm: {
          contactFormUser: "",
          contactFormIsEmail: true,
          contactFormCode: "",
          contactFormEmail: ""
        },
        contactFormRules: {
          contactFormEmail: [{
            required: true,
            validator: (rule, value, callback) => {
              var value = value.replace(/\s*/g, "");
              if (value == "") {
                callback(new Error(this.$t('help.enterEmail')));
              } else if (!isEmail(value)) {
                callback(new Error(this.$t('help.incorrectEmail1')));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }]
        },
        userImg: [],//证件上传图片张数
        GanmeUserImg: [],//订单上传图片张数
        appealInfo: {
          appealAccount: "",
          email: "",
          businessType: "",
          usedEmail: "",
          usedPhone: "",
          registTime: "",
          realName: "",
          IDCard: "",
          IDPhone: "",
          IDPhotos: [],
          description: ""
        },
        appealInfoRules: {
          realName: [{
            required: true,
            message: this.$t('help.enterName'),
            trigger: "blur"
          }],
          usedEmail: [{
            required: true,
            validator: (rule, value, callback) => {
              var value = value.replace(/\s*/g, "");
              if (!isEmail(value) && value != '') {
                callback(new Error(this.$t('help.incorrectEP')));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }],
          usedPhone: [{
            required: true,
            validator: (rule, value, callback) => {
              var value = value.replace(/\s*/g, "");
              if (!isMobile(value) && value != "") {
                callback(new Error(this.$t('help.incorrectPhone')));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }],
          IDCard: [{
            required: true,
            validator: (rule, value, callback) => {
              var value = value.replace(/\s*/g, "");
              if (value == "") {
                callback(new Error(this.$t('help.enterNumber')));
              } else if (value.length != 18) {
                callback(new Error(this.$t('help.idNumber18')));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }]
        },
        gameForm: {
          gameName: "",
          gameArea: "",
          gameNickname: "",
          gameID: "",
          rechargeOrder: [],
          otherInfo: ""
        },
        gameFormRules: {
          gameName: [{
            required: true,
            message: this.$t('help.enterGameName'),
            trigger: "blur"
          }],
          gameNickname: [{
            required: true,
            message: this.$t('help.enterInGameName'),
            trigger: "blur"
          }]
        },
        mallForm: {
          mallFormAddress: "",
          mallFormInfo: "",
          mallFormLedou: "",
          mallFormOrder: "",
          mallFormAdd: "",
          mallFormOther: ""
        },
        cloudServiceForm: {
          cloudServiceFormType: "",
          cloudServiceFormTime: "",
          cloudServiceFormPhoto: ""
        },
        interval: undefined,
        totalCount: 0
      };
    },
    //部件
    components: {},
    //方法表示一个具体的操作，主要书写业务逻辑；
    methods: {
      //移除图片
      gamehandleRemove(file, fileList) {
         for (var i = 0; i < this.GanmeUserImg.length; i++) {
          if (file.uid == this.GanmeUserImg[i].uid) {
            this.GanmeUserImg.splice(i, 1)
            this.gameForm.rechargeOrder.splice(i, 1)
          }
        }
      },
      //预览图片时调用
      gamehandlePictureCardPreview(file) {
        console.log(file);
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      //文件上传之前调用做一些拦截限制
      gamebeforeAvatarUpload(file) {
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
        const extension = testmsg === 'jpg' || testmsg === 'JPG' || testmsg === 'png' || testmsg === 'PNG' || testmsg === 'jpeg' || testmsg === 'JPEG';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!extension) {
          this.$message.error(this.$t('help.onlyJpg'));
          return false; //必须加上return false; 才能阻止
        }
        if (!isLt2M) {
          this.$message.error(this.$t('help.imageSize'));
        }
        return extension && isLt2M;
      },
      //图片上传成功
      gamehandleAvatarSuccess(res, file) {
        var gameUserImgId = {
          uid: file.uid,
          imgId: res.data
        }
        this.GanmeUserImg.push(gameUserImgId);
        this.gameForm.rechargeOrder.push(res.data);
        this.errorreChargeOrderImg = ""
      },
      //图片上传超过数量限制
      gamehandleExceed(files, fileList) {
        this.$message.error(this.$t('help.FileImage'));
        console.log(file, fileList);
      },
      //图片上传失败调用
      gameimgUploadError(err, file, fileList) {
        if(JSON.parse(err.message).code == '3001'){
            this.$message.error(this.$t('help.errorImage1'));
        }else{

          this.$message.error(this.$t('help.errorImage'));
        }
      },
      //移除图片
      handleRemove(file, fileList) {
        for (var i = 0; i < this.userImg.length; i++) {
          if (file.uid == this.userImg[i].uid) {
            this.userImg.splice(i, 1)
            this.appealInfo.IDPhotos.splice(i, 1)
          }
        }
      },
      //预览图片时调用
      handlePictureCardPreview(file) {
        console.log(file);
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      //文件上传之前调用做一些拦截限制
      beforeAvatarUpload(file) {
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
        const extension = testmsg === 'jpg' || testmsg === 'JPG' || testmsg === 'png' || testmsg === 'PNG' || testmsg === 'jpeg' || testmsg === 'JPEG' ;
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!extension) {
          this.$message.error(this.$t('help.onlyJpg'));
          return false; //必须加上return false; 才能阻止
        }
        if (!isLt2M) {
          this.$message.error(this.$t('help.imageSize'));
        }
        return extension && isLt2M;
      },
      //身份证图片上传成功
      handleAvatarSuccess(res, file) {
        console.log(res)
        console.log(file)
        var userImgId = {
          uid: file.uid,
          imgId: res.data
        }
        this.userImg.push(userImgId)
        this.appealInfo.IDPhotos.push(res.data)
        this.errorUserImg = ""
      },
      handleExceed(files, fileList) { //图片上传超过数量限制
        this.$message.error(this.$t('help.twoImage'));
      },
      imgUploadError(err, file, fileList) { //图片上传失败调用
      if(JSON.parse(err.message).code== '3001'){
            this.$message.error(this.$t('help.errorImage1'));
        }else{
          this.$message.error(this.$t('help.errorImage'));
        }
      },
      setSession(n) {
        // this.IDPhone.push(n.data)
      },
      //回到首页
      goHome() {
        this.resetSetItem("isHelpView", 0);
      },
      //获取验证码
      getCode() {
        if (this.totalCount > 0) {
          return
        }
        this.emailNull = ""
        this.errorMsg = ""
        this.disabled = true;
        if (this.contactForm.contactFormEmail.trim() != "" && isEmail(this.contactForm.contactFormEmail.trim())) {
          this.totalCount = 60;
          // this.getCode()    //60秒过倒计时过后才能调用的事件
          this.interval = setInterval(() => {
            this.totalCount--;
            if (this.totalCount === 0) {
              clearInterval(this.interval);
            }
          }, 1000)
          fetch('/appeal/sendCode/?email=' + this.contactForm.contactFormEmail.trim(), {
              method: "GET",
              // credentials: "include"
            }).then(response => response.json())
            .then(data => {
              if (data.code == "200") {} else if (data.code == "1001") {
                clearInterval(this.interval);
                this.totalCount = 0;
                this.errorMsg = this.$t('help.upperLimit')
              } else if (data.code == "1002") {
                clearInterval(this.interval);
                this.totalCount = 0;
                this.errorMsg = data.message
              } else if (data.code == "2007") {
                clearInterval(this.interval);
                this.totalCount = 0;
                this.emailNull = this.$t('help.incorrectEmail1')
              } else if (data.code == "2002") {
                clearInterval(this.interval);
                this.totalCount = 0;
                this.emailNull = this.$t('help.emailNoAgain')
              }
            }).catch((err) => {
              console.log(err)
            })
        } else if (this.contactForm.contactFormEmail.trim() == '') {
          this.emailNull = this.$t('help.enterEmail');
        } else if (!isEmail(this.contactForm.contactFormEmail.trim())) {
          this.emailNull = this.$t('help.incorrectEP');
        } else {
          clearInterval(this.interval);
          this.totalCount = 0;
          this.emailNull = this.$t('help.emptyEmail');
        }
      },
      back(formName) {
        this.emailNull = ""
        this.errorMsg = ""
        this.active == 0 ? (this.active = 0) : this.active--;
      },
      next(formName) {
        var isValid = true;
        var that = this;
        if (Array.isArray(formName)) {
          for (var i = 0; i < formName.length; i++) {
            this.$refs[formName[i]].validate(valid => {
              if (!valid) {
                isValid = false
              }
              if (valid) {
                if (i == formName.length - 1 && isValid) {
                  if (this.active == 0) {
                    this.contactForm.contactFormUser = this.appealInfo.appealAccount = this.startForm.startFormUser
                      .trim();
                    this.appealInfo.businessType = this.startForm.startFormType
                    this.setSession(1)
                    this.active = 1;
                  } else if (this.active == 1) {
                    this.setSession(2)
                    this.active = 2;
                  } else if (this.active == 2) {
                    this.errorUsedEmail = ""
                    this.errorUsedPhone = ""
                    this.errorUserImg = ""
                    this.errorreChargeOrderImg = ""
                    if (this.appealInfo.usedEmail != "" && !isEmail(this.appealInfo.usedEmail)) {
                      this.errorUsedEmail = this.$t('help.incorrectEP');
                    } else if (this.appealInfo.usedPhone != "" && !isMobile(this.appealInfo.usedPhone)) {
                      this.errorUsedPhone = this.$t('help.incorrectPhone');
                    } else if (this.appealInfo.IDPhotos.length < 2) {
                      this.errorUserImg = this.$t('help.uploadId')
                    } else if (this.gameForm.rechargeOrder == "") {
                      this.errorreChargeOrderImg = this.$t('help.uploadOrder');
                    } else {
                      this.bntDisabled = true
                      this.btnLoading = true
                      var data = {
                        appealInfo: {},
                        gameUseInfos: [],
                        mallUseInfo: {},
                        cloudServiceUseInfo: {}
                      };
                      for (let key in this.appealInfo) {
                        if (key !== 'IDPhotos') {
                          this.appealInfo[key] = (this.appealInfo[key]).trim();
                        }
                      }
                      for (let keyg in this.gameForm) {
                        if (keyg !== 'rechargeOrder') {
                          this.gameForm[keyg] = (this.gameForm[keyg]).trim();
                        }
                      }
                      data.appealInfo = this.appealInfo
                      data.gameUseInfos.push(this.gameForm);
                      data.code = this.contactForm.contactFormCode.trim();
                      fetch('/appeal/creatCase', {
                          method: "POST",
                          body: JSON.stringify(data),
                          headers: {
                            'Content-Type': 'application/json'
                          },
                          // credentials: "include"
                        }).then(response => response.json())
                        .then(data => {
                          if (data.code == "200") {
                            this.btnLoading = false
                            this.setSession(3)
                            this.active = 3;
                            this.bntDisabled = false
                            that.$refs['startForm'].resetFields();
                            that.$refs['appealInfo'].resetFields();
                            that.$refs['contactForm'].resetFields();
                            that.$refs['gameForm'].resetFields();
                          } else if (data.code == "2001") {
                            this.btnLoading = false
                            this.bntDisabled = false
                            this.$alert(this.$t('help.phoneNoAgain'), '', {
                              confirmButtonText: this.$t('help.sure'),
                            });
                          } else if (data.code == "2002") {
                            this.btnLoading = false
                            this.bntDisabled = false
                            this.$alert(this.$t('help.emailNoAgain'), '', {
                              confirmButtonText: this.$t('help.sure'),
                            });
                          } else if (data.code == "2006") {
                            this.btnLoading = false
                            this.bntDisabled = false
                            this.$alert(this.$t('appeal.accountNotExist'), '', {
                              confirmButtonText: this.$t('help.sure'),
                            });
                          } else if (data.code == "1003") {
                            this.btnLoading = false
                            this.bntDisabled = false
                            this.$alert(this.$t('help.codeError'), '', {
                              confirmButtonText: this.$t('help.sure'),
                            });
                          }else if (data.code == "1004") {
                            this.btnLoading = false
                            this.bntDisabled = false
                            this.$alert(this.$t('help.invalidCode'), '', {
                              confirmButtonText: this.$t('help.sure'),
                            });
                          }
                        }).catch((err) => {
                          console.log(err)
                        })
                    }
                  } else if (this.active == 3) {
                    this.setSession(0)
                    this.active = 0;
                  }
                }
              } else {
                console.log("error submit!!");
                return false;
              }
            });
          }
        } else {
          this.$refs[formName].validate(valid => {
            if (valid) {
              if (this.active == 0) {
                this.errorUser = ""
                fetch('/appeal/checkResubmit?appealAccount=' + this.startForm.startFormUser.trim(), {
                    method: "GET",
                    // credentials: "include"
                  }).then(response => response.json())
                  .then(data => {
                    if (data.code == "200") {
                      this.errorUser = ""
                      this.contactForm.contactFormUser = this.startForm.startFormUser.trim();
                      this.appealInfo.appealAccount = this.startForm.startFormUser.trim();
                      this.appealInfo.businessType = this.startForm.startFormType
                      this.setSession(1)
                      this.active = 1;
                    } else if (data.code == "2001") {
                      this.errorUser = this.$t('help.againFill');
                    } else if (data.code == "2003") {
                      this.errorUser = this.$t('help.incorrectEP')
                    }
                  }).catch((err) => {
                    console.log(err)
                  })
              } else if (this.active == 1) {
                this.errorMsg = ""
                if (!isEmail(this.contactForm.contactFormEmail.trim())) {
                  this.emailNull = this.$t('help.incorrectEP');
                } else if (!this.contactForm.contactFormCode) {
                  this.errorMsg = this.$t('help.enterCode');
                } else {
                  fetch('/appeal/checkCode?email=' + this.contactForm.contactFormEmail.trim() + "&code=" + this
                      .contactForm.contactFormCode.trim(), {
                        method: "GET",
                        // credentials: "include"
                      }).then(response => response.json())
                    .then(data => {
                      if (data.code == "200" && data.data) {
                        this.emailNull = ""
                        this.errorMsg = ""
                        this.appealInfo.email = this.contactForm.contactFormEmail.trim()
                        this.setSession(2)
                        this.active = 2;
                      } else if (data.code == "200" && !data.data) {
                        this.errorMsg = this.$t('help.codeError')
                      }
                    }).catch((err) => {
                      console.log(err)
                    })
                }
              } else if (this.active == 2) {
                this.active = 3;
              } else if (this.active == 3) {
                this.active = 0;
              }
            } else {
              console.log("error submit!!");
              return false;
            }
          });
        }
      }
    },
    computed: {
      btnText() {
        return this.totalCount !== 0 ?
          `${this.totalCount}s` + this.$t('appeal.resend') :
          this.$t('help.getCode');
      }
    },
    //请求数据
    created() {},
    mounted() {
    }
  };
</script>
<style lang="scss">
  // 修改element-ui自带的rem
  .el-steps--horizontal,
  .el-step__title {
    font-size: 16PX !important;
  }

  .step2-text .getCodeButton {
    margin-top: 10PX!important;
    width: 250PX!important;
    margin-left: 0 !important;
  }

  .el-checkbox {
    font-size: 14PX !important;
  }

  .serveP {
    color: #666;
    margin-bottom: 10PX;
    font-size: 14PX;
  }

  .serveImg {
    border: 1px solid #3e8ddd;
    padding: 8px 15PX;
    border-radius: 4PX;
    text-decoration: none;
    cursor: pointer;

    span {
      color: #3e8ddd;
    }

    img {
      width: 18PX;
      height: 18PX;
      margin-right: 5PX;
      vertical-align: text-top;
    }
  }

  .el-button {
    border-radius: 4px !important;
  }

  .el-step__icon {
    height: 24px !important;
    font-size: 14px !important;
  }

  .el-step__icon.is-icon {
    width: 40PX !important;
    height: 40PX !important;
  }

  .el-step.is-horizontal .el-step__line {
    height: 2PX !important;
    top: 20px !important;
  }

  .el-step.is-center .el-step__line {
    left: 50% !important;
    right: -50% !important;
  }

  .el-step__icon-inner {
    font-size: 24PX !important;
  }

  .el-form-item__content {
    line-height: 40PX !important;
  }
  .el-message-box{
    width: 500PX!important;
    padding-bottom: 0!important;
    font-size: 14PX!important;
  }
  @media screen and (max-width: 700px) {
     .el-message-box{
       width: 280PX!important;
     }
  }
  .el-message-box__content,.el-message-box__title{
    font-size: 14PX!important;
  }
  .el-message-box__content{
    padding: 10PX 20PX!important;
  }
  .el-message-box__message p{
    line-height: 40PX!important;
  }
  .el-message-box__btns{
    padding: 0 10PX 20PX 0!important;
    text-align: center!important;
  }
  .el-message-box__header{
    padding: 10PX 20PX!important;
  }
  .el-message-box__headerbtn{
    font-size: 14PX!important;
    top: 10PX!important;
    right: 10PX!important;
  }
 .mobileSteps .step1-text .el-form-item {
    margin-bottom: 25PX !important;
  }
  .step1-text .el-form-item {
    margin-bottom: 28PX !important;
  }
  .step2-text .el-form-item{
    margin-bottom: 22PX !important;
  }
  .enterEmailClass .el-form-item__error{
    margin-top: -7PX!important;
  }
  .el-input__inner {
    height: 40PX !important;
    border: 1px solid #DCDFE6 !important;
    border-radius: 4PX !important;
    padding: 0 10px !important;
    line-height: 40px;
    font-size: 14PX;
  }

  .el-step__icon-inner[class*=el-icon]:not(.is-status) {
    font-size: 25PX !important;
  }

  .el-step__title {
    line-height: 38PX !important;
  }

  .el-input__icon {
    height: 100% !important;
    width: 25px !important;
    line-height: 40px !important;
  }

  .el-form-item__label {
    line-height: 40px !important;
    padding: 0 12px 0 0 !important;
    font-size: 14PX !important;
    white-space: nowrap;
  }

  .el-form-item__content,
  .el-input {
    font-size: 14PX !important;
  }

  .el-select .el-input .el-select__caret {
    font-size: 12PX !important;
  }

  .back,
  .el-button {
    padding: 11px 20px !important;
    font-size: 14px !important;
  }

  .el-form-item__error {
    font-size: 12px !important;
    line-height: 12PX !important;
    padding-top: 0px !important;
  }

  .el-checkbox__inner {
    width: 14px !important;
    height: 14px !important;
    border: 1px solid #dcdfe6 !important;
    border-radius: 2px !important;
  }

  .el-checkbox__inner:after {
    height: 7px !important;
    left: 4px !important;
    width: 3px !important;
    top: 1px !important;
    border-width: 1px !important;
  }

  .el-checkbox .el-checkbox__label {
    padding-left: 10px !important;
    line-height: 20px !important;
    font-size: 14px !important;
    word-wrap: break-word !important;
    white-space: normal !important;
  }

  .up-btn {
    margin-bottom: 10PX;
  }

  .el-upload__tip {
    color: #666;
    margin-top: 0;
    font-size: 14PX !important;
    line-height: 20PX;
  }

  .el-input__suffix {
    right: 0PX;
    font-size: 16PX;
  }

  .btnCose {
    margin-left: 20PX !important;
  }

  .tip-span {
    display: block;
    color: red;
    padding: 5PX 0 10PX 0;
    font-size: 14PX;
  }

  .step3-text {
    padding: 0 28%;
    margin-top: 50PX;
    font-size: 18PX !important;
  }

  .step3-title {
    display: block;
    text-align: center;
    font-size: 18PX;
    font-weight: 600;
    padding-bottom: 40PX;
  }

  .el-select-dropdown {
    min-width: 160PX !important;
  }

  .el-textarea__inner{
     min-height: 40PX!important;
     padding:10PX!important;
     line-height: 20PX!important;
     font-size: 14PX!important;
     border:1PX solid #dcdfe6!important;
  }
  // 手机端
  .mobileSteps {
    .el-message-box{
      width: 280PX!important;
    }
    .el-checkbox__input{
      vertical-align:super;
    }
    .mobilei18n{
      .el-checkbox__input{
        vertical-align:baseline!important;
      }
    }
    .el-input__inner {
      width: 200PX !important;
      font-size: 10PX;
      line-height: 30PX;
    }

    .el-input__suffix {
      right: 50PX;
    }

    .el-step__title {
      font-size: 15PX !important;
      line-height: 18PX !important;
    }

    .el-textarea__inner {
      width: 200PX !important;
    }
    // .el-form-item {
    //   margin-bottom: 15PX !important;
    // }

    .el-form-item__label {
      width: 115PX !important;
      font-size: 12PX !important;
      line-height: 38PX !important;
      white-space: nowrap;
    }

    .getCodeInput {
      input {
        width: 200PX !important;
      }
    }

    .getCodeButton {
      margin-left: 0 !important;
      width: 200PX!important;
      font-size: 12PX !important;
      margin-top: 10PX!important;
    }

    .el-form-item__content {
      margin-left: 117px !important;
      line-height: 38PX !important;
    }

    .el-input {
      font-size: 12PX;

    }

    .el-form-item__error {
      font-size: 12PX;
      width: 200PX;
    }

    .el-input {
      input {
        height: 30PX !important;
        // width: unset !important;
      }

      select {
        height: 30PX !important;
        width: unset !important;
      }
    }
  }

  .step2-text {
    .el-upload-list--picture .el-upload-list__item {
      margin-top: 10px!important;
      padding: 10px 10px 10px 90px!important;
      height: 92px!important;
      border: 1px solid #c0ccda!important;
    }

    .el-upload-list--picture .el-upload-list__item-thumbnail {
      width: 70px!important;
      height: 70px!important;
      margin-left: -80px!important;
    }

    .el-upload-list--picture .el-upload-list__item.is-success .el-upload-list__item-name {
      line-height: 70px!important;
      margin-top: 0!important;
    }

    .el-upload-list--picture .el-upload-list__item-name i {
      font-size: 70px!important;
      line-height: 1!important;
      left: 9px!important;
      top: 10px!important;
    }

    .el-upload-list__item-name {
      padding-left: 4px!important;
      margin-right: 40px!important;
      font-size: 14PX;
    }

    .el-upload-list--picture .el-upload-list__item-status-label {
      right: -17px!important;
      top: -7px!important;
      width: 46px!important;
      height: 26px!important;
      box-shadow: 0 1px 1px #ccc!important;
    }

    .el-upload-list--picture .el-upload-list__item-status-label i {
      font-size: 12px!important;
      margin-top: 12px!important;
    }

    .el-upload-list__item .el-icon-close {
      top: 5px!important;
      right: 5px!important;
    }

    .el-upload-list__item .el-icon-close-tip {
      top: 5px!important;
      right: 5px!important;
      font-size: 12px!important;
    }
  }

</style>
<style scoped lang="scss">
  form {
    width: 450PX;
  }

  .btn {
    color: rgba(255, 255, 255, 1);
    width: 135PX;
    height: 40PX;
    background: rgba(62, 141, 221, 1);
    border-radius: 4PX;
    float: right;
    margin-right: 55PX;
  }

  .ok-btn {
    color: rgba(255, 255, 255, 1);
    width: 135PX;
    height: 40PX;
    background: rgba(62, 141, 221, 1);
    border-radius: 4PX;
  }

  .form-span {
    padding: 5PX 0 20PX 20PX;
    display: inline-block;
    font-size: 16PX;
    font-weight: 600;
  }

  // .el-form {
  //   padding-left: 30PX;
  // }
  .btn-div {
    overflow: hidden;
    margin-top: 45PX;
    text-align: center;
  }

  .step1-text {
    padding: 0 28%;
    margin-top: 50PX;
  }

  .step1-text p {
    font-size: 14PX;
    line-height: 30PX;
    margin-bottom: 15PX;
  }

  .step2-text .form-span {
    padding: 5PX 0 10PX 0;
    display: inline-block;
    font-size: 16PX;
    font-weight: 600;
  }

  .step2-text {
    padding: 0 28%;
    margin-top: 50PX;
  }

  .back {
    color: rgba(51, 51, 51, 1);
    width: 135PX;
    height: 40PX;
    background: rgba(215, 215, 215, 1);
    border: 1PX solid rgba(184, 184, 184, 1);
    border-radius: 4PX;
    float: left;
  }

  // 手机端
  .mobileSteps {
    .el-form-item {
      margin-left: -30PX !important;
      // margin-bottom: 15PX!important;
    }

    .step1-text,
    .step2-text,
    .step3-text {
      padding: 0 25PX;
      margin-top: 25PX;

      p {
        font-size: 14PX;
        line-height: 20pX;
      }
    }

    .btn {
      width: 110PX !important;
      font-size: 14PX !important;
      margin-right: 0 !important;
    }

    .back {
      width: 110PX !important;
      font-size: 14PX;
    }

    form {
      width: auto;

    }

  }
</style>



// WEBPACK FOOTER //
// src/components/cards/steps.vue